"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyCartTitle = exports.InfoBlock = exports.TotalPrice = exports.TotalPriceBlock = exports.ShippingBlock = exports.GoToCartButton = exports.CartFooterContainer = exports.CartItemsContainer = exports.CloseButton = exports.Title = exports.Header = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../UI/Typography"));
const LinkAsButton_1 = __importDefault(require("../../Components/LinkAsButton"));
exports.Container = styled_components_1.default.div `
  height: 100%;
  width: ${props => props.theme.constants.blockWidth.xl1}px;
  background: ${props => props.theme.palette.BW_100};
  position: absolute;
  right: ${props => (props.isModalOpen ? '0' : `-${props.theme.constants.blockWidth.xl1}`)}px;
  transition: ${props => props.theme.animations.primary};
  display: flex;
  flex-direction: column;
  @media (max-width: ${props => props.theme.constants.blockWidth.xl1}px) {
    width: 100%;
  }
`;
exports.Header = styled_components_1.default.div `
  padding: ${props => props.theme.spacing.s4}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px ${props => props.theme.constants.borderWidth.md}px ${props => props.theme.spacing.s1}px
    rgba(0, 0, 0, 0.06);
  margin-bottom: ${props => props.theme.spacing.s4}px;
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
`;
exports.CloseButton = styled_components_1.default.button `
  background-color: transparent;
  border: 0;
`;
exports.CartItemsContainer = styled_components_1.default.div `
  height: inherit;
  overflow: auto;
  padding: 0 ${props => props.theme.spacing.s4}px ${props => props.theme.spacing.s4}px
    ${props => props.theme.spacing.s4}px;
`;
exports.CartFooterContainer = styled_components_1.default.div `
  background: ${props => props.theme.palette.LIGHT_GRAY_20};
  padding: ${props => props.theme.spacing.s4}px;
  height: ${props => props.theme.constants.blockHeight.s11}px;
`;
exports.GoToCartButton = (0, styled_components_1.default)(LinkAsButton_1.default) `
  width: 100%;
  margin-top: ${props => props.theme.spacing.s4}px;
  color: ${props => props.theme.palette.BW_100};
  background: ${props => props.theme.palette.BLUE_100};
  &:hover {
    background: ${props => props.theme.palette.BLUE_GRAY_100};
  }
`;
exports.ShippingBlock = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  > div {
    color: ${props => props.theme.palette.LIGHT_BLACK};
  }
`;
exports.TotalPriceBlock = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  margin-top: ${props => props.theme.spacing.s1}px;
  > h5 {
    :first-child {
      color: ${props => props.theme.palette.SVART};
    }
  }
`;
exports.TotalPrice = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
`;
exports.InfoBlock = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.s2}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > div {
    color: ${props => props.theme.palette.LIGHT_BLACK};
  }
`;
exports.EmptyCartTitle = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  text-align: center;
  margin-top: ${props => props.theme.spacing.l4}px;
`;
exports.default = {
    Container: exports.Container,
    Header: exports.Header,
    Title: exports.Title,
    CloseButton: exports.CloseButton,
    CartItemsContainer: exports.CartItemsContainer,
    CartFooterContainer: exports.CartFooterContainer,
    GoToCartButton: exports.GoToCartButton,
    ShippingBlock: exports.ShippingBlock,
    TotalPriceBlock: exports.TotalPriceBlock,
    TotalPrice: exports.TotalPrice,
    InfoBlock: exports.InfoBlock,
    EmptyCartTitle: exports.EmptyCartTitle
};
